import React, { useState, useEffect, useContext } from 'react';
//import PropTypes from 'prop-types';
import SiteWrapper from "../../SiteWrapper.react";
import Select from "react-select";
import { Grid, Button, Icon, Form } from 'tabler-react';
import { Crud_Catalogos, Crud_error } from '../../herramientas/Crud_Catalogos';
import { Exportar } from '../../herramientas/Excel';
import { data } from 'jquery';
import { timeToYearmonthDay } from "../../herramientas/DateFormat";
import * as conf from "../../config/config";
import { softphoneContext } from "../../context/softphoneContext";
import { TablePageable } from "../../Helpers";
const perfil= JSON.parse(sessionStorage.getItem("perfil"));

const ReportesLLAmadasPage = () => {
  const softphone = useContext(softphoneContext);
  const [funcionalidades, setFuncionalidades]= useState([]);
  const [troncales, setTroncales] = useState([]);
  const [fecha1, setFecha1] = useState(timeToYearmonthDay(new Date().getTime()));
  const [fecha2, setFecha2] = useState(timeToYearmonthDay(new Date().getTime()));
  const [tipoLLamada, settipoLLamada ] = useState( { value: "", label: "Todas los tipos" } );
  const [telefono, setTelefono] = useState("");
  const [grupos, setGrupos] = useState([]);
  const [ grupo, setGrupo ] = useState( { value: 0, label: "Seleccione una opción", data: null } );
  const [agentes, setAgentes] = useState([]);
  const [agente, setAgente ] = useState( { value: "", label: "Todos los agentes", data: null } );
  const [ reporte, setReporte ] = useState( []);
  const [reporteProcesado, setReporteProcesado] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedUniqueId, setSelectedUniqueId] = useState(null);
  const [historialLlamada, setHistorialLlamada] = useState([]);


  useEffect(() => {
    crud("get", "", "", "funcionalidades/reporte_llamadas/"+perfil.id, "funcionalidades");
  },[]);

  useEffect(() => {
    if(funcionalidades.length){
      crud("get", "", "", "softphone_configuracion" , "softphonePlataforma");
    }
  },[funcionalidades]);

  useEffect(() => {
    if(troncales.length){
      crud("get", "", "", "softphone/grupos_list" , "grupos");
    }
  },[troncales]);

  useEffect(() => {
    if(grupo.value){
      crud("get", "", "", "softphone/agentes/grupo/"+ grupo.value , "agentes");
    }
  },[grupo]);

  const crud=(metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {
    return Crud_Catalogos(catalogo, "movimientos", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
        switch (metodo) {
            case "get":
              if( stateVar === "funcionalidades"){
                setFuncionalidades(returnVal);
              }
              if( stateVar === "softphonePlataforma"){
                setTroncales(returnVal);
              }
              if( stateVar === "grupos"){
                let gruposTemp= [{ value: 0, label: "Seleccione una opción", data: null }];
                const troncalesV1= [
                      {
                          "id": 14,
                          "idGrupo": 8,
                          "extension": "6008",
                          "caller_id": "525541696722",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 23,
                          "idGrupo": 30,
                          "extension": "6030",
                          "caller_id": "525597080060",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 60,
                          "idGrupo": 15,
                          "extension": "6015",
                          "caller_id": "525541609731",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 4,
                          "idGrupo": 24,
                          "extension": "6024",
                          "caller_id": "525597080043",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 16,
                          "idGrupo": 7,
                          "extension": "6007",
                          "caller_id": "525541697026",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 9,
                          "idGrupo": 2,
                          "extension": "6002",
                          "caller_id": "525541609705",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 1579,
                          "idGrupo": 10,
                          "extension": "6010",
                          "caller_id": "525513280795",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 193,
                          "idGrupo": 1,
                          "extension": "6001",
                          "caller_id": "525541603232",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 952,
                          "idGrupo": 19,
                          "extension": "6019",
                          "caller_id": "525597080037",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 529,
                          "idGrupo": 14,
                          "extension": "6014",
                          "caller_id": "525541605873",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 292,
                          "idGrupo": 6,
                          "extension": "6006",
                          "caller_id": "525541696314",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 530,
                          "idGrupo": 13,
                          "extension": "6013",
                          "caller_id": "525597080038",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 721,
                          "idGrupo": 22,
                          "extension": "6022",
                          "caller_id": "525597080041",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 557,
                          "idGrupo": 31,
                          "extension": "6031",
                          "caller_id": "525597080061",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 24,
                          "idGrupo": 28,
                          "extension": "6028",
                          "caller_id": "525597080058",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 1315,
                          "idGrupo": 29,
                          "extension": "6029",
                          "caller_id": "525597080059",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 1612,
                          "idGrupo": 11,
                          "extension": "6011",
                          "caller_id": "525541708515",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 886,
                          "idGrupo": 4,
                          "extension": "6004",
                          "caller_id": "525541609846",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 61,
                          "idGrupo": 20,
                          "extension": "6020",
                          "caller_id": "525597080056",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 820,
                          "idGrupo": 27,
                          "extension": "6027",
                          "caller_id": "525597080066",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 985,
                          "idGrupo": 21,
                          "extension": "6021",
                          "caller_id": "525597080040",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 1843,
                          "idGrupo": 37,
                          "extension": "6037",
                          "caller_id": "525597080049",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 1316,
                          "idGrupo": 17,
                          "extension": "6017",
                          "caller_id": "525597080034",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 1,
                          "idGrupo": 3,
                          "extension": "6003",
                          "caller_id": "525541725576",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 1678,
                          "idGrupo": 9,
                          "extension": "6009",
                          "caller_id": "525585261165",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 3,
                          "idGrupo": 12,
                          "extension": "6012",
                          "caller_id": "525541606023",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 1381,
                          "idGrupo": 23,
                          "extension": "6023",
                          "caller_id": "525597080042",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 1810,
                          "idGrupo": 26,
                          "extension": "6026",
                          "caller_id": "525597080045",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 1909,
                          "idGrupo": 35,
                          "extension": "6035",
                          "caller_id": "525519466850",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 1711,
                          "idGrupo": 18,
                          "extension": "6018",
                          "caller_id": "525597080035",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 1777,
                          "idGrupo": 25,
                          "extension": "6025",
                          "caller_id": "525597080044",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      },
                      {
                          "id": 1513,
                          "idGrupo": 5,
                          "extension": "6005",
                          "caller_id": "525541696665",
                          "estatus": true,
                          "softphoneConfiguracionId": 1
                      }
                    ];
                for( let g of returnVal){
                  //let troncalTemp= troncales.filter(t=> t.idGrupo === g.id);
                  let troncalTemp= troncalesV1.filter(t=> t.idGrupo === g.id);
                  if( troncalTemp.length === 1){
                    g.extension= troncalTemp[0].extension;
                    gruposTemp.push({ value: g.id, label: g.name, data: g });
                    if( g.id === softphone.getValues().grupo){
                      setGrupo(gruposTemp[gruposTemp.length-1]);
                    }
                  }
                }
                setGrupos(gruposTemp);
              }

              if( stateVar === "agentes"){
                let agentesTemp= [{ value: "", label: "Todos los agentes", data: null }];
                for( let a of returnVal){
                  agentesTemp.push({ value: a.id, label: a.name+" "+ a.lastname, data: a });
                  if( a.id === softphone.getValues().idPbx){
                    setAgente(agentesTemp[agentesTemp.length-1]);
                  }
                }
                setAgentes(agentesTemp);
              }
              if( stateVar === "reporte"){
                setReporte(returnVal);
                // Procesar el reporte para obtener un único elemento por uniqueid
                const procesado = procesarReporte(returnVal);
                setReporteProcesado(procesado);
              }
            break;
            default:
                break;
        }
    }).catch(err => { console.log(err); });
  }

  // Función para calcular el tiempo total de llamada por uniqueid
  const calcularTiempoTotal = (uniqueid, reporteData) => {
    const llamadasRelacionadas = reporteData.filter(item => item.uniqueid === uniqueid);
    const tiempoTotal = llamadasRelacionadas.reduce((suma, item) => {
      return suma + parseInt(item.duration || 0);
    }, 0);
    
    // Convertir segundos a formato HH:MM:SS
    const formatearTiempo = (segundos) => {
      const horas = Math.floor(segundos / 3600);
      const minutos = Math.floor((segundos % 3600) / 60);
      const segs = segundos % 60;
      
      return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}:${segs.toString().padStart(2, '0')}`;
    };
    
    return formatearTiempo(tiempoTotal);
  };
  // Función para procesar el reporte y obtener un único elemento por uniqueid
  const procesarReporte = (reporteData) => {
    // Agrupar por uniqueid
    const agrupados = reporteData.reduce((acc, item) => {
      if (!acc[item.uniqueid]) {
        acc[item.uniqueid] = [];
      }
      acc[item.uniqueid].push(item);
      return acc;
    }, {});

    // Procesar cada grupo para obtener el registro representativo
    const procesados = Object.keys(agrupados).map(uniqueid => {
      const registros = agrupados[uniqueid];
      
      // Buscar el registro con disposition "ANSWERED"
      const answered = registros.find(registro => registro.disposition === "ANSWERED");
      
      if (answered) {
        // Si hay un registro ANSWERED, usarlo como base
        return {
          ...answered,
          // Calcular el tiempo total sumando todas las duraciones
          tiempoTotal: registros.reduce((suma, reg) => suma + parseInt(reg.duration || 0), 0),
          // Mantener información de todos los registros si es necesario
          totalRegistros: registros.length
        };
      } else {
        // Si no hay ANSWERED, tomar el último según calldate
        const ordenados = registros.sort((a, b) => new Date(b.calldate) - new Date(a.calldate));
        const ultimo = ordenados[0];
        
        return {
          ...ultimo,
          // Calcular el tiempo total sumando todas las duraciones
          tiempoTotal: registros.reduce((suma, reg) => suma + parseInt(reg.duration || 0), 0),
          // Mantener información de todos los registros si es necesario
          totalRegistros: registros.length
        };
      }
    });

    return procesados;
  };

  // Actualizar la columna "Tiempo de Llamada" para usar tiempoTotal
  const formatearTiempo = (segundos) => {
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    const segs = segundos % 60;
    
    return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}:${segs.toString().padStart(2, '0')}`;
  };

  // Función para obtener el historial de una llamada específica
  const obtenerHistorialLlamada = (uniqueid) => {
    const historial = reporte.filter(item => item.uniqueid === uniqueid);
    // Ordenar por calldate para mostrar cronológicamente
    return historial.sort((a, b) => new Date(a.calldate) - new Date(b.calldate));
  };

  // Función para formatear la duración
  const formatearDuracion = (segundos) => {
    const mins = Math.floor(segundos / 60);
    const secs = segundos % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Función para obtener el color del estado
  const getStatusColor = (disposition) => {
    switch(disposition) {
      case 'ANSWERED': return '#28a745';
      case 'NO ANSWER': return '#dc3545';
      case 'BUSY': return '#ffc107';
      case 'FAILED': return '#dc3545';
      default: return '#6c757d';
    }
  };

  // Función para obtener el icono del estado
  const getStatusIcon = (disposition) => {
    switch(disposition) {
      case 'ANSWERED': return '✓';
      case 'NO ANSWER': return '✗';
      case 'BUSY': return '⏳';
      case 'FAILED': return '⚠';
      default: return '○';
    }
  };

  const ModalHistorial = () => {
  if (!showModal) return null;

  return (
    <div 
      className="modal fade show" 
      style={{ 
        display: 'block', 
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 1050
      }}
      onClick={(e) => {
        // Cerrar modal al hacer clic en el backdrop
        if (e.target === e.currentTarget) {
          setShowModal(false);
        }
      }}
    >
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content" style={{ maxHeight: '90vh' }}>
          <div className="modal-header sticky-top bg-white border-bottom">
            <h5 className="modal-title">
              Historial de Llamada - ID: {selectedUniqueId}
              <small className="text-muted ms-2">
                ({historialLlamada.length} eventos)
              </small>
            </h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={() => setShowModal(false)}
              aria-label="Cerrar"
            ></button>
          </div>
          <div 
            className="modal-body" 
            style={{ 
              maxHeight: 'calc(90vh - 140px)', 
              overflowY: 'auto',
              padding: '1rem'
            }}
          >
            <div className="timeline">
              {historialLlamada.map((evento, index) => (
                <div key={index} className="timeline-item mb-3">
                  <div className="row">
                    <div className="col-2 text-center">
                      <div 
                        className="timeline-marker rounded-circle d-flex align-items-center justify-content-center"
                        style={{ 
                          backgroundColor: getStatusColor(evento.disposition),
                          width: '40px', 
                          height: '40px',
                          color: 'white',
                          fontWeight: 'bold',
                          fontSize: '14px'
                        }}
                      >
                        {getStatusIcon(evento.disposition)}
                      </div>
                      {index < historialLlamada.length - 1 && (
                        <div 
                          className="timeline-line"
                          style={{ 
                            width: '2px', 
                            height: '60px', 
                            backgroundColor: '#dee2e6',
                            margin: '5px auto'
                          }}
                        ></div>
                      )}
                    </div>
                    <div className="col-10">
                      <div className="card shadow-sm">
                        <div className="card-body p-3">
                          <div className="row">
                            <div className="col-md-6">
                              <h6 className="card-title mb-1">
                                <span 
                                  className="badge"
                                  style={{ backgroundColor: getStatusColor(evento.disposition) }}
                                >
                                  {evento.disposition}
                                </span>
                              </h6>
                              <p className="card-text mb-1">
                                <strong>Fecha:</strong> {evento.calldate}
                              </p>
                              <p className="card-text mb-1">
                                <strong>Duración:</strong> {formatearDuracion(parseInt(evento.duration || 0))}
                              </p>
                              <p className="card-text mb-1">
                                <strong>Tipo:</strong> {evento.type}
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p className="card-text mb-1">
                                <strong>Origen:</strong> {evento.src}
                              </p>
                              <p className="card-text mb-1">
                                <strong>Destino:</strong> {evento.dst}
                              </p>
                              <p className="card-text mb-1">
                                <strong>Usuario:</strong> {evento.peeraccount}
                              </p>
                              <p className="card-text mb-1">
                                <strong>Canal:</strong> {evento.dstchannel}
                              </p>
                            </div>
                          </div>
                          {evento.recordingfile && (
                            <div className="mt-2">
                              <audio controls className="w-100">
                                <source src={evento.recordingfile} type="audio/mpeg" />
                                Your browser does not support the audio element.
                              </audio>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="modal-footer sticky-bottom bg-white border-top">
            <div className="d-flex justify-content-between w-100">
              <small className="text-muted">
                Total de eventos: {historialLlamada.length}
              </small>
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={() => setShowModal(false)}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

  // Función para abrir el modal con el historial
  const abrirModalHistorial = (uniqueid) => {
    setSelectedUniqueId(uniqueid);
    const historial = obtenerHistorialLlamada(uniqueid);
    setHistorialLlamada(historial);
    setShowModal(true);
  };

  return (
    <SiteWrapper>
      { funcionalidades.filter(f=> f.nombre === "ver_reporte").length?
        <div className='container-fluid p-6'>
          <h5> Grabaciones de llamadas </h5>
          <hr color='white'/>
          <div className='row mt-5'>
            <div className='col-12'>
              <TablePageable
                titulo={
                  <div className="row">
                    <div className='col'>
                      <label>Fecha inicio</label>
                      <input className="form-control" type="date" id="start" name="trip-start"
                        value={fecha1}
                        onChange={(e)=>{
                          setFecha1(e.target.value);
                          if( new Date(e.target.value).getTime() > new Date(fecha2).getTime() ){
                            setFecha2(e.target.value);
                          }else{
                            if( (new Date(fecha2).getTime() - new Date(e.target.value).getTime()) > (31*24*60*60*1000) ){
                              setFecha2(timeToYearmonthDay(new Date(e.target.value).getTime()+(31*24*60*60*1000)));
                            }
                          }
                        }}
                        min="2024-05-01" max={timeToYearmonthDay(new Date().getTime())} />
                    </div>
                    <div className='col'>
                      <label>Fecha fin</label>
                      <input className="form-control" type="date" id="start" name="trip-start"
                        value={fecha2}
                        onChange={(e)=>{
                          setFecha2(e.target.value);
                          if( new Date(e.target.value).getTime() < new Date(fecha1).getTime() ){
                            setFecha1(e.target.value);
                          }else{
                            if( (new Date(e.target.value).getTime() - new Date(fecha1).getTime()) > (31*24*60*60*1000) ){
                              setFecha1(timeToYearmonthDay(new Date(e.target.value).getTime()-(31*24*60*60*1000)));
                            }
                          }
                        }}
                        min="2024-05-01" max={timeToYearmonthDay(new Date().getTime())} />
                    </div>
                    <div className='col'>
                      <label>Tipo de llamada</label>
                      <Select
                        value={tipoLLamada}
                        onChange={ (e)=> settipoLLamada(e) }
                        options={[
                          { value: "", label: "Todas los tipos" },
                          { value: 'inbound', label: 'inbound'},
                          { value: 'outbound', label: 'outbound'},
                          { value: 'internal', label: 'internal'},
                          { value: 'clicktocall', label: 'clicktocall'},
                          ]} />
                    </div>
                    <div className='col' hidden={ funcionalidades.filter(f=> f.nombre === "grupos_agentes").length === 0}>
                      <label>Telefono</label>
                      <input className="form-control" type="number" value={ telefono } onChange={(e)=>setTelefono(e.target.value)} placeholder="número" />
                    </div>
                    <div className='col' hidden={ funcionalidades.filter(f=> f.nombre === "grupos_agentes").length === 0}>
                      <label>Grupos</label>
                      <Select value={grupo} onChange={ (e)=> setGrupo(e) } options={grupos} />
                    </div>
                    <div className='col' hidden={ funcionalidades.filter(f=> f.nombre === "grupos_agentes").length === 0}>
                      <label>Agentes</label>
                      <Select value={agente} onChange={ (e)=> setAgente(e) } options={agentes} />
                    </div>
                    <div className='col-1'>
                        <i className="fa fa-refresh text-primary btn"
                          style={{ fontSize: "40px"}}
                          data-toggle="tooltip"
                          data-placement="top"
                          title={"Actualizar"}
                          onClick={()=>{
                            if(grupo.data){
                              crud("get", "", "",
                                "softphone/reporte?f1="+fecha1+" 00:00:00&f2="+fecha2+" 23:59:59&tipo="+tipoLLamada.value+"&phone="+telefono+"&grupo="+grupo.data.extension+"&agente="+agente.value,
                                "reporte");
                            }
                          }}></i>
                    </div>
                  </div>
                }
                lista= { reporteProcesado }
                columnas={
                  [
                    { columna: "calldate", label: "Fecha" },
                    { columna: "uniqueid", label: "ID" },
                    { columna: "accountcode", label: "Cuenta" },
                    { columna: "peeraccount", label: "Usuario" },
                    { columna: "src", label: "Origen" },
                    { columna: "dst", label: "Destino" },
                    { 
                      columna: "tiempo_total", 
                      label: "Tiempo de Llamada",
                      form: (e) => {
                        return formatearTiempo(e.tiempoTotal || 0);
                      },
                      valor: (e)=> {
                        return formatearTiempo(e.tiempoTotal || 0);
                      }
                    },
                    { 
                      columna: "tiempo_total_seg", 
                      label: "Tiempo en seg",
                      form: (e) => {
                        return e.tiempoTotal;
                      },
                      valor: (e)=> {
                        return e.tiempoTotal;
                      }
                    },
                    { columna: "type", label: "Tipo"},
                    { columna: "disposition", label: "Disposición" },
                    { 
                      columna: "detalle", 
                      label: "Detalle",
                      form: (e) => {
                        // Contar cuántos registros tiene este uniqueid
                        const totalEventos = reporte.filter(item => item.uniqueid === e.uniqueid).length;
                        return (
                          <div 
                            className="btn"
                            onClick={() => abrirModalHistorial(e.uniqueid)}
                            title={`Ver historial completo (${totalEventos} eventos)`}
                          >
                            <i className="fa fa-eye"></i> Ver ({totalEventos})
                          </div>
                        );
                      }
                    },                    
                    { columna: "audio", label: "Audio",
                      form: (e)=>{
                        if(funcionalidades.filter(f=> f.nombre === "audio").length){
                          //console.log(e.uniqueid+": "+e.recordingfile);
                          return <audio controls key={e.uniqueid}>
                            <source src={e.recordingfile} type="audio/mpeg" />
                            Your browser does not support the audio element.
                          </audio>
                        }else{
                          return "";
                        }
                      }
                    },
                  ]
                }
                id= "uniqueid"/*
                selected={(e)=>{
                  const etiquetaTemp= stor.etiquetas_object.filter(et => et.id === e.idEtiqueta);
                  if( etiquetaTemp.length !== 1){
                    alert("Precaución la incidencia: \n"+ e.nombre + " \n No esta configurada para envío de notificaciones "+ "\n Contacta a sistemas");
                  }
                }}*/
                csvname= {funcionalidades.filter(f=> f.nombre === "exportar").length?("Reporte de llamadas "+grupo.label): null}
                /*
                resaltarFuncion={(e)=>{
                  return incidencias.filter(i => i.incidencia.id === e.id  ).length ? true: false
                }}
                resaltarColor={(e)=>{
                  const etiquetaTemp= stor.etiquetas_object.filter(et => et.id === e.idEtiqueta);
                  if( etiquetaTemp.length !== 1){
                    return "rgba(242, 151, 151, 0.41)";
                  }
                  return "rgba(58, 223, 149, 0.25)";
                }}*/
                paginacion={true}
                elementosPorPagina={15}
              />
            </div>
          </div>
        </div>
      :null
      }
      <ModalHistorial />
    </SiteWrapper>
  );
}


export default ReportesLLAmadasPage;